// extracted by mini-css-extract-plugin
module.exports = {"paywall":"paywall_paywall__zccJv","paywallLockTitle":"paywall_paywallLockTitle__eP0rt"};